import { useEffect, useState } from 'react';
import { NavLink, withRouter, useLocation } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config';
import { DELETE, GET, newFetch, PUT, POST } from '../../../../../helpers/fetch';
import LayoutContext from '../../../../../store/Layout/contexts';
import docImg from '../../../../../assets/icons/document.png';
import BadgeStatus from '../../../../../common/BadgeStatus';
import Modal from '../../../../../components/Modal';

const { SERVER_URL } = config;

const EditLeave = ({
  history,
  match: {
    params: { leave_id, approver_level },
  },
}) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const accessType = localStorage.getItem('type');
  const [status, setStatus] = useState(0);
  const [adminRemarks, setAdminRemarks] = useState('');
  const [file, setFile] = useState([]);
  const [origAdminRemarks, setOrigAdminRemarks] = useState([]);
  const [origStatus, setOrigStatus] = useState([]);
  const [filePath, setFilePath] = useState([]);
  const [siteId, setSiteId] = useState('');

  const [client, setClient] = useState('');
  const [selectedAssociate, setSelectedAssociate] = useState('');
  const [leaveType, setLeaveType] = useState('');
  const [leaveFrom, setLeaveFrom] = useState('');
  const [leaveTo, setLeaveTo] = useState('');
  const [totalDays, setTotalDays] = useState('');
  const [attachments, setAttachments] = useState([]); // array of {orig_file, new_file}
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [remarks, setRemarks] = useState('');

  const location = useLocation();
  const from = location.state?.from || '/leaves/approval';

  const padding = 90; // adjust this to your needs
  let height = 375 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // dd/mm/yyyy
  };

  const fetchLeave = async () => {
    const api_path = `/leaves/${leave_id}`;
    const response = await newFetch(GET, api_path);

    if (response.success) {
      const data = response.data;

      setSelectedAssociate(
        `${data.associate.first_name} ${data.associate.last_name}`
      );
      setLeaveType(data.leave_type);
      setLeaveFrom(formatDate(data.leave_from));
      setLeaveTo(formatDate(data.leave_to));
      setTotalDays(data.no_of_days);
      setAttachments(data.documents);
      setStatus(data.status);
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClient(response.data);
    }
  };

  const handleLeaveApproval = async (action, remarksText = '') => {
    try {
      const response = await newFetch(POST, '/leaves/bulk-approval', {
        action,
        leave_ids: [leave_id],
        remarks: remarksText,
      });

      if (response.success) {
        const actionPastTense =
          action === 'cancel'
            ? 'cancelled'
            : action === 'pending'
            ? 'set to pending'
            : `${action}d`;

        ToastUtil.success(`Successfully ${actionPastTense} leave`);
        history.push(from);
      } else {
        ToastUtil.error(response.message || `${action} failed`);
      }
    } catch (err) {
      ToastUtil.error('Network error during approval');
      console.error(err);
    }
  };
  useEffect(() => {
    fetchClients();
    fetchLeave();
  }, []);

  const LeaveActionModal = ({ action, show, onClose, onSubmit }) => {
    const [localRemarks, setLocalRemarks] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isReject = action === 'reject';
    const isCancel = action === 'cancel';
    const isApprove = action === 'approve';

    const buttonClass = isReject
      ? 'btn-danger'
      : isCancel
      ? 'btn-warning'
      : 'btn-brand';
    const buttonText = isReject ? 'Reject' : isCancel ? 'Cancel' : 'Approve';

    useEffect(() => {
      if (show) setLocalRemarks('');
    }, [show]);

    const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        setIsSubmitting(true);
        await onSubmit(action, localRemarks);
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <Modal showModal={show} customStyle={style}>
        <form
          className="d-flex flex-column justify-content-between flex-grow-1 h-100"
          onSubmit={handleSubmit}
        >
          <h5>Remarks{isReject && <span className="text-danger">*</span>}</h5>

          <div className="d-flex flex-column mt-3">
            <div className="mb-2">
              <textarea
                id={`remarks-${action}`}
                className="form-control"
                rows={4}
                value={localRemarks}
                onChange={(e) => setLocalRemarks(e.target.value)}
                placeholder="Enter remarks..."
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-auto pt-3 border-top gap-2">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary adjust-fs adjust-shadow"
            >
              Close
            </button>
            <button
              type="submit"
              className={`btn ${buttonClass} adjust-fs adjust-shadow`}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Processing...' : buttonText}
            </button>
          </div>
        </form>
      </Modal>
    );
  };

  const statusStr = String(status || '').toLowerCase();
  const isPendingStatus = statusStr.includes('pending');
  const isPendingCancellation = statusStr.includes('pending cancellation');

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={from}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to List
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Manage Leave | {leave_id}</h5>
              </div>
            </div>
            <div
              style={{ marginTop: '1rem', padding: '0.1rem 3rem 6rem 3rem' }}
            >
              {/* Action button positioned just above the content */}
              <div className="d-flex justify-content-end mb-2">
                <UncontrolledDropdown>
                  <DropdownToggle
                    className="btn btn-primary dropdown-toggle shadow-none"
                    style={{ backgroundColor: '#5156BE' }}
                  >
                    Action
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    {/* Approve - Show only if NOT Approved */}
                    {statusStr !== 'approved' && (
                      <DropdownItem onClick={() => setOpenApproveModal(true)}>
                        Approve
                      </DropdownItem>
                    )}

                    {/* Reject - Show only if NOT Rejected */}
                    {statusStr !== 'rejected' && (
                      <DropdownItem onClick={() => setOpenRejectModal(true)}>
                        Reject
                      </DropdownItem>
                    )}

                    {/* Cancel - Show only if NOT Cancelled and NOT Pending Cancellation */}
                    {statusStr !== 'cancelled' && !isPendingCancellation && (
                      <DropdownItem onClick={() => setOpenCancelModal(true)}>
                        Cancel
                      </DropdownItem>
                    )}

                    {/* Pending - Show only if status does NOT contain 'pending' */}
                    {!isPendingStatus && !isPendingCancellation && (
                      <DropdownItem
                        onClick={() => handleLeaveApproval('pending')}
                      >
                        Pending
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              <div className="d-flex border rounded adjust-shadow">
                <div
                  className="flex-grow-1 bg-white col-md-7"
                  style={{ padding: '2.25rem' }}
                >
                  {/* Status */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Status</strong>
                    <p className="adjust-fs text-muted">
                      <BadgeStatus status={status} />
                    </p>
                  </div>

                  {/* Client */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Client</strong>
                    <p className="adjust-fs text-muted">{client.name}</p>
                  </div>

                  {/* Associate Name */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Associate Name</strong>
                    <p className="adjust-fs text-muted">{selectedAssociate}</p>
                  </div>

                  {/* Leave Type */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Leave Type</strong>
                    <p className="adjust-fs text-muted">{leaveType}</p>
                  </div>

                  {/* Leave From & To (same row) */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', gap: '1rem' }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <strong>Leave From</strong>
                      <p className="adjust-fs text-muted">{leaveFrom}</p>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <strong>Leave To</strong>
                      <p className="adjust-fs text-muted">{leaveTo}</p>
                    </div>
                  </div>

                  {/* Total Days */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Total Days</strong>
                    <p className="adjust-fs text-muted">{totalDays}</p>
                  </div>

                  {/* Attachments */}
                  <div
                    className="row col-md-12"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <strong>Attachments</strong>
                    {attachments && attachments.length > 0 ? (
                      attachments.map((file, idx) => (
                        <div
                          key={idx}
                          className="d-flex align-items-center mb-2"
                          style={{ fontSize: '14px', color: '#6c757d' }}
                        >
                          <a
                            href={`${SERVER_URL}/storage/leaves/${file.new_file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center me-2"
                          >
                            <img
                              src={docImg}
                              alt="Document Icon"
                              style={{ width: '32px', height: '32px' }}
                            />
                          </a>
                          <span>{file.orig_file}</span>
                        </div>
                      ))
                    ) : (
                      <span style={{ fontSize: '14px', color: '#6c757d' }}>
                        -
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className="flex-grow-1 bg-white col-md-5"
                  style={{ paddingTop: '2.25rem' }}
                ></div>
              </div>
            </div>

            {/* Footer buttons section removed */}

            {/* Approve Modal */}
            <LeaveActionModal
              action={isPendingCancellation ? 'approve' : 'approveFinal'}
              show={openApproveModal}
              onClose={() => setOpenApproveModal(false)}
              onSubmit={handleLeaveApproval}
            />

            {/* Reject Modal */}
            <LeaveActionModal
              action="reject"
              show={openRejectModal}
              onClose={() => setOpenRejectModal(false)}
              onSubmit={handleLeaveApproval}
            />

            {/* Cancel Modal */}
            <LeaveActionModal
              action="cancel"
              show={openCancelModal}
              onClose={() => setOpenCancelModal(false)}
              onSubmit={handleLeaveApproval}
            />
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditLeave);
